// src/components/common/LinearProgressWithLabel.jsx

import React from 'react';
import PropTypes from 'prop-types';
import { LinearProgress, Typography, Box } from '@mui/material';

const LinearProgressWithLabel = ({ value, label, showPercentage = true }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" value={value} />
      </Box>
      {showPercentage && (
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {label || `${Math.round(value)}%`}
          </Typography>
        </Box>  
      )}
    </Box>
  );
};

LinearProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
  label: PropTypes.string,
  showPercentage: PropTypes.bool,
};

export default LinearProgressWithLabel;